<template>
  <div>
    <v-row>
      <v-col cols="12" md="6" class="pa-2">
        <ListArticlesOverview></ListArticlesOverview>
      </v-col>
      <v-col cols="12" md="6" class="pa-2">
        <GraphArticlesPerWeek></GraphArticlesPerWeek>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import GraphArticlesPerWeek from "./GraphArticlesPerWeek.vue";
import ListArticlesOverview from "./ListArticlesOverview.vue";

export default {
  components: { GraphArticlesPerWeek, ListArticlesOverview },
};
</script>

<style lang="scss" scoped>
</style>